import { ReactElement } from 'react';
import {
  AddCircleOutline,
  ArrowForward,
  Assignment,
  ChromeReaderMode,
  Edit,
  FileCopy,
  ImportContacts,
  InsertDriveFileOutlined,
  LinkOff,
  MoreHoriz,
  PlayArrow,
} from '@mui/icons-material';
import _ from 'lodash';
import { IconType } from './types';

export const TYPE_TO_ICON: Record<IconType, ReactElement> = {
  addCircleOutline: <AddCircleOutline />,
  arrowForward: <ArrowForward />,
  assignment: <Assignment />,
  chromeReaderMode: <ChromeReaderMode />,
  edit: <Edit />,
  fileCopy: <FileCopy />,
  importContacts: <ImportContacts />,
  insertDriveFileOutlined: <InsertDriveFileOutlined />,
  linkOff: <LinkOff />,
  moreHoriz: <MoreHoriz />,
  playArrow: <PlayArrow />,
};
